module.exports = ".error-message{background-color:#E41736;color:#fff;font-size:16px;display:inline-block;padding:5px 10px;border-radius:10px}@media screen and (max-height: 640px){.login-form{margin-top:-30px}}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/accounts/login/login.component.scss
// module id = 785
// module chunks = 0